var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape Copy 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50712 4.24375C9.59488 4.32375 9.71104 4.375 9.8414 4.375C10.1086 4.375 10.3254 4.165 10.3254 3.90625V0.625C10.3254 0.28 10.0363 0 9.68007 0H6.29204C6.02487 0 5.80804 0.21 5.80804 0.46875C5.80804 0.595 5.86096 0.7075 5.94356 0.7925C5.94485 0.79375 5.9455 0.795313 5.94614 0.796875C5.94679 0.798437 5.94743 0.8 5.94872 0.80125L7.15292 1.96875L4.10822 4.9175C3.7933 5.2225 3.7933 5.7175 4.10822 6.0225C4.42315 6.32625 4.93425 6.32625 5.24918 6.0225L8.29517 3.0725L9.49808 4.23875C9.49937 4.24 9.50099 4.24062 9.5026 4.24125C9.50421 4.24187 9.50583 4.2425 9.50712 4.24375ZM1.29068 8.4375V2.8125C1.29068 2.64 1.43523 2.5 1.61334 2.5H5.1627L3.87203 1.25H1.29068C0.578223 1.25 0 1.81 0 2.5V8.75C0 9.44125 0.578223 10 1.29068 10H7.74405C8.4578 10 9.03473 9.44125 9.03473 8.75V6.25L7.74405 5V8.4375C7.74405 8.61 7.5995 8.75 7.42138 8.75H1.61334C1.43523 8.75 1.29068 8.61 1.29068 8.4375Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.1915b407470d4a67528017ed707d1e18.svg";
export { ForwardRef as ReactComponent };